import APIURLConstants from "../common/ApiURLConstants";
import APIHelper from "../common/ApiHelper";
import { authHeader } from "../helper";

export const GameAuditBlobsService = {
  getGameAuditBlobsData,
  getVideoDashboardDisplayFlag,
};

async function getGameAuditBlobsData(EventId, LastModifiedDate) {
  const response = await APIHelper.get(
    APIURLConstants.GET_GAME_AUDIT_BLOBS(EventId, LastModifiedDate),
    authHeader()
  );
  return response;
}

async function getVideoDashboardDisplayFlag() {
  const response = await APIHelper.get(
    APIURLConstants.GET_REVISED_GAME_AUDIT_DISPLAY_FLAG,
    authHeader()
  );
  return response;
}
